module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_round__oval.afd12f84.png";